export default "__VITE_ASSET__5625b0f3__"